export default __webpack_public_path__ + "static/media/fistClassUnderline.e86cfad1.svg";